import { useState, useEffect, Fragment } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition, RadioGroup } from '@headlessui/react'
import { FormSelect, Button } from "../../components";
import { authStaff } from '../../utils/constants';
import useConfigOptions from '../../hooks/useConfigOptions';
import { useSelector, useDispatch } from "react-redux";
import { selectAccessToken } from "../../slices/staffSlice";
import { useNavigate } from 'react-router-dom';
import { fetchRequests } from '../../Requests/getRequests';
import { show } from '../../slices/toastSlice';
import { CheckIcon } from '@heroicons/react/24/solid';

function Rollover({ rollover, setRollover, setRolloverLoanId, setRolloverLoanBal }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const { optionsYN } = useConfigOptions();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [phone, setPhone] = useState("");
    const [searchProcess, setSearchProcess] = useState(false);
    const [searchedLoans, setSearchedLoans] = useState([]);
    const [selectedItem, setSelectedItem] = useState(false);

    const setSelected = (selected) => {
        setRolloverLoanId(selected?.loanId);
        setRolloverLoanBal(selected?.balance);
        setSelectedItem(true);
    };

    const closeModal = () => {
        setIsOpen(false)
    }

    const handleSearch = async(e) => {
        e.preventDefault();
        setSearchProcess(true);

        let url = `/loans/staff/search-loans`;
        let headers = authStaff(accessToken);

        let params = {
            phone,
            state : 'active'
        }

        let res = await fetchRequests(url, "GET", headers, params, {});
        setSearchProcess(false);

        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }

        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : `${res.message}`
            }))
            return;
        }

        res = res?.map((item) => {
            return {
                _id : item._id,
                loanId : item.loanId,
                signedName : item.signedName,
                type : item.type,
                amountReq : item?.amountReq,
                accountInfo : {
                    ...item.accountInfo
                },
                balance : item.accountInfo.totalPayment - item.transactions.filter((item) => item.type === 'repay').map((item => item.amount)).reduce((prev, curr) => prev + parseInt(curr), 0)
            }
        })

        setSearchedLoans(res);

    }

    useEffect(() => {
        if(rollover === 'Yes'){
            setIsOpen(true);
        }
    },[rollover]);

    return (
        <>
            <div className='col-span-full mt-10'>
                <h3 className='text-xl font-medium leading-6 text-gray-800 dark:text-gray-200'>
                    Loan Rollover Option
                </h3>
            </div>

            <FormSelect 
                label='Is this loan a rollover?'
                name='rollover'
                id="rollover"
                content={optionsYN}
                value={rollover}
                setValue={setRollover}
            />

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={closeModal}>
                    <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                        <div className="fixed inset-0 bg-black/25 dark:bg-black/50" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                                <DialogPanel className="w-full max-w-md md:max-w-xl transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all">
                                    <DialogTitle as="h3" className="text-lg font-medium leading-6 text-gray-900 dark:text-gray-50">
                                        Search and select loan to rollover
                                    </DialogTitle>
                                    <div className="my-4">
                                        <label htmlFor="loanId" className='form-label'>
                                            Enter the phone number associated with the loan to rollover:
                                        </label> 

                                        <input type="text" name="loanId" id="loanId" className='form-input' onChange={(e) => setPhone(e.target.value)} required />
                                    </div>

                                    {searchedLoans && searchedLoans?.length > 0 && (
                                        <>
                                        <h4 className='my-3 text-gray-800 dark:text-gray-200'>Select loan</h4>
                                        <RadioGroup onChange={setSelected}>
                                            {searchedLoans.map((loan) => (
                                                <RadioGroup.Option key={loan._id} value={loan} className={({ active, checked }) => `${ active ? 'ring-2 ring-white/60 ring-offset-2 ring-offset-sky-300'  : ''} ${checked ? 'bg-light-blue text-white' : 'bg-white'} relative flex cursor-pointer rounded-lg px-5 py-4 shadow-sm border border-slate-200 hover:border-light-blue transition duration-100 delay-75 mb-2`}>
                                                    {({ active, checked }) => (
                                                        <div className='flex items-center justify-between w-full'>
                                                            <div className='flex items-center'>
                                                                <div className='text-sm'>
                                                                    <RadioGroup.Label as="p" className={`font-medium mb-1 ${checked ? "text-white" : "text-gray-900"}`}>
                                                                        {`${loan?.signedName}`}{' '}
                                                                    <span aria-hidden="true">&middot;</span>{' '}{loan.type}
                                                                    </RadioGroup.Label>
                                                                    <RadioGroup.Description as="span" className={`text-sm inline text-gold-500 ${checked ? "text-sky-100" : "text-gray-500"}`}>
                                                                    <span>
                                                                    {`Amount requested: ${loan?.amountReq}gh`}
                                                                    </span>{' '}
                                                                    <span aria-hidden="true">&middot;</span>{' '}
                                                                    <span>{`Balance on loan: ${loan?.balance}gh`}</span>
                                                                    </RadioGroup.Description>
                                                                </div>
                                                            </div>
                                                            {checked && (
                                                                <div className="shrink-0 text-light-blue bg-white rounded-full p-1">
                                                                    <CheckIcon className="h-4 w-4" />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </RadioGroup.Option>
                                            ))}
                                        </RadioGroup>
                                        </>
                                    )}

                                    <div className='inline-flex items-center justify-between w-full mt-2 space-x-2'>
                                        <Button 
                                            btnText="Search"
                                            btnType="button"
                                            btnClasses="form-button"
                                            btnFunction={handleSearch}
                                            processing={searchProcess}
                                        />
                                        
                                        {selectedItem && (
                                        <Button 
                                            btnText="Attach loan"
                                            btnType="button"
                                            btnClasses="form-button-default"
                                            btnFunction={closeModal}
                                        />
                                        )}

                                        <Button 
                                            btnText="Cancel"
                                            btnType="button"
                                            btnClasses="form-button-default"
                                            btnFunction={closeModal}
                                        />
                                    </div>
                                </DialogPanel>
                            </Transition.Child>
                        </div>
                    </div>

                </Dialog>
            </Transition>
        </>
    )
}

export default Rollover